import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import {apiBaseUrl} from './Config';

class AdminDeleteAdventureModal extends React.Component {
    constructor(props) {
	super(props);

	this.resource = apiBaseUrl + "adminAdventures/" + this.props.adventure.id;

	this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
	fetch(this.resource, {
	    method: "DELETE",
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Content-Type": "application/json"
	    }
	})
	    .then((response) => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		if (!response.ok) {
		    throw new Error("Kunde inte radera");
		}
		
		return response.json();
	    })
	    .then((result) => {
		this.props.onSuccess();
	    })
	    .catch((error) => {
		this.props.onError();
	    });
	
	event.preventDefault();
    }

    render() {
	var adventure = this.props.adventure;
	
	return (
	    <Modal show={this.props.show} onHide={this.props.onHide}>
		<Modal.Header closeButton>
		    <Modal.Title>Ta bort &auml;ventyr</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		    Radera {adventure.name}?
		</Modal.Body>
		<Modal.Footer>
		    <Button variant="alumni" onClick={this.props.onHide}>Avbryt</Button>
		    <Button variant="alumni" onClick={this.handleSubmit}>Radera</Button>
		</Modal.Footer>
	    </Modal>
	);
    }
}

export default AdminDeleteAdventureModal;
